// extracted by mini-css-extract-plugin
export default {"violations":"BJcqd5rccGWjbED8sCTA","issue":"UG_PQeUly5jYyqTLE5lB","policy-description":"FZ_JdkW9j3XukXqo_hHG","risk":"C1EOjWEW4krvQp0sh0ku"};